import get from 'lodash/get'
import type { TreeFilterOptions, TreeFilterPredicate } from './types'
import cloneDeep from 'lodash/cloneDeep'
import set from 'lodash/set'

/**
 * This function works like Array.filter but traverses the tree structure and returns a new filtered tree.
 * @param root - The root node of the tree.
 * @param childrenName -
 * @param predicate - A function that tests whether a node should be included.
 */
export function filterTree<T>(root: T, predicate: TreeFilterPredicate<T>, options?: TreeFilterOptions): T | null {
  if (!root) return null

  const clonedRoot = cloneDeep(root)
  const childrenName = options?.childrenName ?? 'items'
  const startsFromRoot = options?.startsFromRoot ?? true

  const traverse = (traverseRoot: T, level: number) => {
    const children = get(traverseRoot, childrenName, []) as T[] //(traverseRoot?.[childrenName] ?? []) as T[]

    const filteredChildren: T[] = []

    children.forEach((child, index) => {
      //if it can go here, we need to traverse the child
      const filtered = traverse(child, level + 1) //treeFilter(child, predicate, options)
      const shouldInclude = predicate(child, level + 1, index, root)
      if (shouldInclude && filtered) {
        filteredChildren.push(filtered)
      }
    })

    let result = {
      ...traverseRoot,
    }

    result = set<T>(result as object, childrenName, filteredChildren)

    return result
  }

  if (startsFromRoot) {
    //we need to run the predicate the root
    const shouldInclude = predicate(clonedRoot, 0, 0, root)
    //if the root failed already, no need to traverse it's children
    if (!shouldInclude) {
      return null
    }
  }

  //if it can go here, we need to traverse the root
  const result = traverse(clonedRoot, 0)
  return result
}
